var map = {
	"./de-DE/dataset": 22167,
	"./en-US/dataset": 36311,
	"./fr-FR/dataset": 84281,
	"./ja-JP/dataset": 56404,
	"./ko-KR/dataset": 63149,
	"./pl-PL/dataset": 62581,
	"./pt-BR/dataset": 4954,
	"./ro-RO/dataset": 16927,
	"./uk-UA/dataset": 62492,
	"./vi-VN/dataset": 1397,
	"./zh-Hans/dataset": 1320,
	"./zh-Hant/dataset": 17129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6502;